/* eslint-disable max-len */
(function($) {
	document.addEventListener('DOMContentLoaded', function (){
		document.addEventListener('basket:update', ()=> {
			if (!window || !window.rw.basket) return;
			const list = window.rw.basket; //shortcut
			if (!list) return;

			$('.js-datalayer-click').each((index, link)=> {
				const cardTriggerDataId = $(link).attr('data-id');
				const $triggerButton = $(link)
					.parents('.product-item__description')
					.find('.product-item__bottom-buy-button');

				const $bottomControls = $($triggerButton)
					.parents('.product-item__description')
					.find('.product-item__bottom-controls');

				const $inputCardInBasketCount = $bottomControls.find('.product-item__counter-input');

				list.length && list.forEach((item)=> {
					if (item.product_id === cardTriggerDataId) {
						if ($triggerButton && !$triggerButton.hasClass('product-item__bottom-buy-button--disabled')) {
							$triggerButton.addClass('product-item__bottom-buy-button--disabled');
						}

						if ($bottomControls && !$bottomControls.hasClass('product-item__bottom-controls--visible')) {
							$bottomControls.addClass('product-item__bottom-controls--visible');
						}

						$inputCardInBasketCount.val(item.quantity);
					}
				});

				if (!list.find((i)=> i.product_id === cardTriggerDataId)) {
					if ($triggerButton && $triggerButton.hasClass('product-item__bottom-buy-button--disabled')) {
						$triggerButton.removeClass('product-item__bottom-buy-button--disabled');
					}

					if ($bottomControls && $bottomControls.hasClass('product-item__bottom-controls--visible')) {
						$bottomControls.removeClass('product-item__bottom-controls--visible');
					}

					$inputCardInBasketCount.val(0);
				}
			});
		});

		document.addEventListener('basket:update', ()=>{
			if (window && window.products_in_basket) {

				const list = window.products_in_basket;
				if (!list) return;
				const listKeys = Object.keys(list);

				$('.product-card__btn-panel').each((index, productControls)=> {
					const productId = $(productControls).find('.js-oneclick').attr('data-product');
					const $counter = $(productControls).find('.product-card__counter');
					const $counterInput = $counter.find('.product-card__counter-input');

					listKeys.length && listKeys.forEach((key)=> {
						if (key == productId) {
							if (!$(productControls).hasClass('product-card__btn-panel--in-basket')) {
								$(productControls).addClass('product-card__btn-panel--in-basket');
							}
							$counterInput.val(list[key]);
						}
					});

					if (!list[productId]) {
						if ($(productControls).hasClass('product-card__btn-panel--in-basket')) {
							$(productControls).removeClass('product-card__btn-panel--in-basket');
						}

						$counterInput.val(0);
					}
				});
			}
		});

		window.rw.getItemBasketQuantity = (itemId = 0) => {
			if (!window.rw.basket) return 0;
			const globalBasket = window.rw.basket; //shortcut

			const item = (globalBasket.length ? globalBasket.find((item)=> Number(item.product_id) === Number(itemId)) : null);
			return item ? Number(item.quantity) : 0;
		};

		document.dispatchEvent(new CustomEvent('basket:update'));
	});
// eslint-disable-next-line no-undef
})(jQuery);
